export default __webpack_public_path__ + "static/media/bg.15cbbe0c.png";